// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProductBuyerHeader":"cy_a bhs_rl","ProductBuyerHeader__username":"cy_b bhs_ua"};